import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-confirm',
  template: `
    <div *ngIf="data.icon" class="icon-container" [class.error]="data.error" [class.success]="!data.error">
      <mat-icon>{{ data.icon }}</mat-icon>
    </div>
    <h1 matDialogTitle class="mb-05 title" [class.error]="data.error" [class.success]="!data.error">{{ data.title }}</h1>
    <div mat-dialog-content class="mb-1 message" [class.error]="data.error" [class.success]="!data.error">{{ data.message }}</div>
    <div mat-dialog-content *ngIf="data.options">
      <p>Por favor selecione {{data.messageOptions}}:</p>
      <mat-form-field>
      <mat-select placeholder="{{data.messageOptions}}?" [(ngModel)]="selectedChoice" [compareWith]="compareChoices">
        <mat-select-trigger>
          <mat-icon *ngIf="getOptionSvgIcon(selectedChoice)" [svgIcon]="getOptionSvgIcon(selectedChoice)" style="vertical-align: middle; margin-right:8px;"></mat-icon>
          <mat-icon *ngIf="!getOptionSvgIcon(selectedChoice) && getOptionIcon(selectedChoice)" style="vertical-align: middle; margin-right:8px;">{{getOptionIcon(selectedChoice)}}</mat-icon>
          <span>{{ getOptionLabel(selectedChoice) }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let opt of data.options" [value]="opt">
          <mat-icon *ngIf="getOptionSvgIcon(opt)" [svgIcon]="getOptionSvgIcon(opt)" style="vertical-align: middle; margin-right:8px;"></mat-icon>
          <mat-icon *ngIf="!getOptionSvgIcon(opt) && getOptionIcon(opt)" style="vertical-align: middle; margin-right:8px;">{{getOptionIcon(opt)}}</mat-icon>
          <span>{{ getOptionLabel(opt) }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    </div>
    <div mat-dialog-content *ngIf="data.containsText">
      <p>{{data.messageOptions}}
      </p>
      <mat-form-field appearance="outline" style="width: 100%;">
        <input matInput placeholder="{{data.title}}" [(ngModel)]="selectedText" type="text">
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
    <button
    type="button"
    mat-raised-button
    color="primary"
    (click)="confirmSelection()">OK</button>
    &nbsp;
    <span fxFlex></span>
    <button  *ngIf="!data.disableCancel"
    type="button"
    color="accent"
    mat-raised-button
    (click)="dialogRef.close(false)">Cancelar</button>
    </div>`,
  styles: [`
    .icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      border-radius: 999px;
      margin: 0 auto 8px;
      background: #e8f5e9;
      color: #2e7d32;
    }

    .icon-container.error {
      background: #ffebee;
      color: #c62828;
    }

    .icon-container.success {
      background: #e8f5e9;
      color: #2e7d32;
    }

    .title.error {
      color: #b71c1c;
    }

    .title.success {
      color: #1b5e20;
    }

    .message {
      white-space: pre-line;
      line-height: 1.5;
      border-left: 4px solid #90a4ae;
      padding-left: 12px;
    }

    .message.error {
      border-left-color: #ef5350;
      background: #fff8f8;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    .message.success {
      border-left-color: #66bb6a;
      background: #f7fff7;
      padding-top: 8px;
      padding-bottom: 8px;
    }
  `]
})



export class AppComfirmComponent {
  selectedChoice: any = true;

  selectedText: any = '';


  constructor(
    public dialogRef: MatDialogRef<AppComfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedChoice = data.defaultOption;
    this.selectedText = this.data.selectedText;

  }
  confirmSelection() {
    this.dialogRef.close(this.data?.containsText !== undefined ? this.selectedText : this.selectedChoice);
  }

  compareChoices(a: any, b: any): boolean {
    if (a === b) {
      return true;
    }
    if (!a || !b) {
      return false;
    }
    return a.label === b.label;
  }

  getOptionLabel(option: any): string {
    if (option?.label) {
      return option.label;
    }
    if (option === null || option === undefined) {
      return '';
    }
    return String(option);
  }

  getOptionSvgIcon(option: any): string | null {
    if (option?.svgIcon) {
      return option.svgIcon;
    }

    const normalized = this.getOptionLabel(option).toLowerCase();
    if (this.includesAny(normalized, ['whatsapp'])) {
      return 'whatsapp';
    }

    return null;
  }

  getOptionIcon(option: any): string | null {
    if (option?.icon) {
      return option.icon;
    }

    const normalized = this.getOptionLabel(option).toLowerCase();

    // Prioridade explícita para evitar ambiguidade em rótulos com múltiplas ações.
    const rules: Array<{ keywords: string[]; icon: string }> = [
      { keywords: ['cancelar'], icon: 'cancel' },
      { keywords: ['excluir', 'deletar', 'remover'], icon: 'delete' },
      { keywords: ['aprovar', 'confirmar'], icon: 'check_circle' },
      { keywords: ['imprimir'], icon: 'print' },
      { keywords: ['baixar', 'download'], icon: 'download' },
      { keywords: ['remessa'], icon: 'receipt_long' },
      { keywords: ['conta'], icon: 'account_balance' },
      { keywords: ['enviar'], icon: 'send' },
      { keywords: ['copiar'], icon: 'content_copy' }
    ];

    for (const rule of rules) {
      if (this.includesAny(normalized, rule.keywords)) {
        return rule.icon;
      }
    }

    return null;
  }

  private includesAny(text: string, keywords: string[]): boolean {
    return keywords.some((keyword) => text.includes(keyword));
  }

}
